import React, {useState, useMemo, useContext} from 'react';
import styled from 'styled-components'

import Icon from 'components/icons/icon';
import SearchSort from 'components/pages/search/searchSort';

import theme, {bp, color} from 'settings/theme';

import {SearchContext} from 'services/searchService';



type Props = {
    toggleSidebar: () => void
};


// Component
const Component: React.FC<Props> = (props) => {

  const search = useContext(SearchContext);

  const filterCount = useMemo(() => {
  
    let filters = Object.entries(search.params ?? {});

    const lockedFilters = search.lockedFilters ?? [];
    filters = filters.filter(item => lockedFilters.includes(item[0].toLowerCase()) == false);

    return filters?.length ?? 0;
      
  }, [search.params]);


  // Keyword Box
  const [keywordsInput, setKeywordsInput] = useState('');

  const handleKeywordsChange = (e) => {
    setKeywordsInput(e.target.value);
  };

  const handleKeywordsSubmit = (e) => {

    e.preventDefault();

    search.setParam!('keywords', keywordsInput);
    search.doSearch!();

    setKeywordsInput('');

  };


  return (
    <StyledComponent className="searchSmallToolbar">

      <div className="searchSmallToolbar-search">
        <div className="searchSmallToolbar-search-inputWrapper">

          <form onSubmit={handleKeywordsSubmit}>
            <label>
              <input name="search" type="text" value={keywordsInput} onChange={handleKeywordsChange} placeholder="Search Products" />
            </label>
            <button type="submit">
              <Icon iconName="magnifying-glass" />
            </button>
          </form>

        </div>
      </div>

      <div className="searchSmallToolbar-sort">
        <SearchSort />
      </div>

      <div className="searchSmallToolbar-filters">
        <button onClick={props.toggleSidebar}>
          <div className="searchSmallToolbar-filters-icon">
            <Icon iconName="filter"  />
          </div>
          <div className="searchSmallToolbar-filters-text">
            {filterCount} Filter<span>{filterCount !== 1 ? `s` : ``}</span><span className="hideOnSmall">&nbsp;Set</span>
          </div>
        </button>
      </div>

    </StyledComponent>
  );

};


export default Component;




// Styles
const StyledComponent = styled.div`

  display: flex;
  position: sticky;
  z-index: 1;
  top: 60px;
  width: 100%;
  height: 42px;
  font-family: ${theme.typography.fontFamilySecondary};
  color: ${color.grey(20)};
  border-bottom: solid 1px ${color.lines};
  background-color: white;

  .hideOnSmall{
    display: none;
  }


  .searchSmallToolbar-search{

    display: flex;
    align-items: center;
    flex: 1 1 auto;
    border-right: solid 1px ${color.lines};

    .searchSmallToolbar-search-inputWrapper{

      display: flex;
      align-items: stretch;
      position: relative;
      width: 100%;
      height: 100%;
      padding: 5px 8px;

    }

    label{
      display: block;
      width: 100%;
      height: 100%;
    }

    input{
      width: 100%;
      height: 100%;
      padding-left: 8px;
      padding-right: 34px;
      color: ${color.grey(20)};
      border: none;
      border-radius: 4px;
      background-color: rgba(245, 247, 249, 1)
    }

    input:focus{
      padding-left: 7px;
      outline: none;
      border: solid 1px ${color.blue(50)};
    }

    button{
      position: absolute;
      right: 8px;
      top: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
    }

    .icon{

      width: 14px;
      height: 14px;

      svg{
        fill: ${color.grey(40)};
      }

    }

  }


  .searchSmallToolbar-sort{
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    flex: 0 0 auto;
    border-right: solid 1px ${color.lines};
  }

  .searchSmallToolbar-filters{

    display: flex;
    align-items: stretch;
    justify-content: stretch;
    flex: 0 0 auto;

    button{

      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding-left: 12px;
      padding-right: 12px;
      transition: all 0.15s ease-out;

      &:hover, &:focus{
        background-color: ${color.pageBackground};
      }

    }

    .searchSmallToolbar-filters-icon{

      margin-right: 8px;

      .icon{

        width: 14px;
        height: 14px;

        svg{
          fill:${color.grey(20)};
        }

      }

    }

    .searchSmallToolbar-filters-text{
      position: relative;
      top: 1px;
    }

  }


  @media (min-width: ${bp(2)}) {

    .hideOnSmall{
      display: inline-block;
    }

  }


  @media (min-width: ${bp(3)}) {

    height: 60px;

    .searchSmallToolbar-search{

      .searchSmallToolbar-search-inputWrapper{
        padding: 10px 10px;
      }

      input{
        padding-left: 12px;
        padding-right: 34px;
        border-radius: 4px;
      }

      input:focus{
        padding-left: 11px;
      }

      button{
        top: 10px;
        right: 10px;
        width: 40px;
        height: 40px;
      }

      .icon{
        width: 16px;
        height: 16px;
      }

    }

    .searchSmallToolbar-filters{

      button{
        padding-left: 24px;
        padding-right: 22px;
      }

      .searchSmallToolbar-filters-icon{

        margin-right: 12px;

        .icon{
          position: relative;
          top: 1px;
          width: 18px;
          height: 18px;
        }

      }

      .searchSmallToolbar-filters-text{
        font-size: 16px;
        top: 1px;
      }

    }


  }

  @media (min-width: ${bp(4)}) {
    display: none;
  }

`;



